import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API });

const deviceId = () => {
  try {
    let id = localStorage.getItem("smileton_device");
    if (!id) {
      id = crypto.randomUUID();
      localStorage.setItem("smileton_device", id);
    }
    return id;
  } catch {
    return "";
  }
};

api.interceptors.request.use((c) => {
  const id = deviceId();
  if (id) c.headers["X-Device-Id"] = id;
  return c;
});

export const rememberPhone = (bookingId, phone) => {
  try { localStorage.setItem(`smileton_phone_${bookingId}`, phone); } catch {}
};
export const recallPhone = (bookingId) => {
  try { return localStorage.getItem(`smileton_phone_${bookingId}`); } catch { return null; }
};

export const errMsg = (e, fallback = "Something went wrong. Please try again.") => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return (d[0]?.msg || fallback).replace("Value error, ", "");
  return d || fallback;
};

export const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;

export const slotLabel = (t) => {
  const [h, m] = t.split(":").map(Number);
  return `${h % 12 || 12}:${String(m).padStart(2, "0")} ${h < 12 ? "AM" : "PM"}`;
};

export const fmtDate = (ds, opts = { weekday: "short", day: "numeric", month: "short", year: "numeric" }) =>
  new Date(`${ds}T00:00:00`).toLocaleDateString("en-IN", opts);

export const timeOptions = () => {
  const out = [];
  for (let m = 6 * 60; m <= 22 * 60; m += 30) {
    out.push(`${String(Math.floor(m / 60)).padStart(2, "0")}:${String(m % 60).padStart(2, "0")}`);
  }
  return out;
};
